<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
let customerId = window.localStorage.getItem("customerId");
import Vue from "vue";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "suggestions",
        key: "id",
        makeMain: "",
        url: {
          del: "/admin/system/suggestions/del",
          list: "/admin/system/suggestions/list",
        },
        output: false,
      },
      menus: [],
      query: {},
      actions: [
        {
          label: "新增建议",
          icon: "md-add",
          onClick: this.toAdd,
          auth: "",
          type: "info",
        },
      ],
      filters: [
        {
          label: "科室",
          KeyEnter: this.search,
          name: "deskName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        // {
        //   title: "序号",
        //   type: "index",
        //   width: 80,
        //   align: "center",
        // },

        {
          title: "科室",
          width: 150,
          align: "left",
          key: "deskName",
          // sortable: true,
          tooltip: "true",
        },
        {
          title: "地址",
          width: 150,
          align: "left",
          key: "address",
          // sortable: true,
          tooltip: "true",
        },
        {
          title: "问题描述",
          minWidth: 100,
          align: "left",
          key: "problemDescription",
          // sortable: true,
          tooltip: "true",
        },
        {
          title: "改善建议",
          minWidth: 100,
          align: "left",
          key: "suggestionsImprovement",
          // sortable: true,
          tooltip: "true",
        },
        // {
        //   title: "经济效益",
        //   width: 100,
        //   align: "center",
        //   key: "economicBenefits",
        //   // sortable: true,
        //   tooltip: "true",
        // },
        {
          title: "状态",
          key: "state",
          width: 90,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state === 1
                ? "待讨论"
                : row.state === 2
                ? "已否决"
                : row.state === 3
                ? "已采纳"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 190,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              const row = param.row;
              if (row.state == 1) {
                return (
                  <Button
                    size="small"
                    onClick={() => this.toEdit(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    编辑
                  </Button>
                );
              }
            },
            (vm, h, currentRow, param) => {
              const row = param.row;
              if (row.state == 1) {
                return (
                  <Button
                    size="small"
                    onClick={() => this.toChange(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    否决
                  </Button>
                );
              }
            },
            (vm, h, currentRow, param) => {
              const row = param.row;
              if (row.state == 1) {
                return (
                  <Button
                    size="small"
                    onClick={() => this.toInfo(currentRow)}
                    type="default"
                    style={{
                      border: "none",
                      color: "#4991ff",
                    }}
                  >
                    采纳
                  </Button>
                );
              }
            },
            "del",
          ],
        },
      ],
    };
  },
  created() {},
  methods: {
    toEdit(row) {
      $utils.url.push({
        name: "suggestions_add",
        query: { action: "edit", kv: row.id },
      });
    },
    toAdd() {
      $utils.url.push({
        name: "suggestions_add",
        query: { action: "add" },
      });
    },
    //转单
    async toChange(row) {
      let q = {
        id: row.id,
        state: 2,
      };
      let res = await $utils.api.load(
        "/admin/system/suggestions/edit",
        q,
        "put"
      );
      try {
        if (res && res.code == 200) {
          this.search();
        }
      } catch (e) {
        console.log(e);
      }
    },
    //详情
    async toInfo(row) {
      let q = {
        id: row.id,
        state: 3,
      };
      let res = await $utils.api.load(
        "/admin/system/suggestions/edit",
        q,
        "put"
      );
      try {
        if (res && res.code == 200) {
          this.search();
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped></style>
